// For date format to 'MM-DD-Y'
import moment from "moment"; //Import Moment

//Vue moment js to show human readable date
Vue.filter("formatDate", function(date) {
	return date ? moment(date).format('MM-DD-Y') : '';
});

//To check any type of string , as well as HTMl(converted from vue blade) and return with specific length with Normal string
Vue.filter("descriptionsLength", function(data, outputLength) {
	let output = data;
	if(output != null && output.length > outputLength) {
		output = output.substring(0, outputLength) + '...';
	}
	return output;
});

//When User as sender, Return with name, email, etc..
Vue.filter("userNameEmail", function(selfID, otherUserID, dataName, dataEmail, nameLength, emailLength, url) {
	if(selfID == otherUserID) {
		return `<h5 class="font-size-14 mb-1">
		<a href="${url}" class="text-dark">Self</a></h5>`;
	} else {
		if(dataName.length > nameLength) {
			dataName = dataName.substring(0, nameLength) + "...";
		}
		if(dataEmail.length > emailLength) {
			dataEmail = dataEmail.substring(0, emailLength) + "...";
		}
		return `<h5 class="font-size-14 mb-1">
		<a href="${url}" class="text-dark">${dataName}</a></h5>
		<p class="text-muted mb-0">${dataEmail}</p>`;
	}
});

Vue.filter("onlyFirstLetter", function(string) {
	if(string != null) {
		return string.substring(0, 1).toUpperCase();
	}
	return 'N/A';
});

Vue.filter("getUserType", function(isEmp, userTypeId, is_ultra_admin) {
	let userType = '';
	if(userTypeId == 2) {
		userType = 'Enterprise Partner';
	}else if(userTypeId == 3) {
		userType = 'Tax Company';
	}else if(userTypeId == 1) {
		userType = 'Admin';
		if(is_ultra_admin) {
			userType = 'Ultra Admin';
		}
	}else {
		userType = 'Tax Payer';
	}

	if(isEmp == 1) {
		userType += ' (OE)';
	}
	return userType;
});

Vue.directive('digitsonly', (el, binding) => {
	if (/[\d\.]+/i.test(el.value)) {
		const match = el.value
		.replace(/\D+/g, '')
		.match(/([^\d]*\d[^\d]*){1,10}$/)[0];
		const part1 = match.length > 2 ? `(${match.substring(0, 3)})` : match;
		const part2 = match.length > 3 ? ` ${match.substring(3, 6)}` : '';
		const part3 = match.length > 6 ? `-${match.substring(6, 10)}` : '';
		const finalFormat = `${part1}${part2}${part3}`;

		if (finalFormat.length > 14) {
			console.log(finalFormat);
		} else {
			el.value = finalFormat;
		}
	} else {
		let newValue = el.value.replace(/[a-zA-Z]+/ig, '');
		el.value = newValue;
	}
});

Vue.directive('onlyForteen', (el, binding) => {
	if (el.value.length > 14) el.value = el.value.slice(0, 13);
});
